export default __webpack_public_path__ + "static/media/cockadoo-global-news.f565f79c.png";